<template lang="pug">
    .animations(ref='animation')
        .checkmates
            svg(width='100%' viewBox='-15 0 477 277' preserveAspectRatio='xMidYMid meet')

                path(ref='parn' d='M168.39 155.449C145.937 150.679 136.112 122.501 130.468 97.1054L134.007 96.4464C134.499 96.3548 134.8 95.79 134.61 95.3168C134.132 94.3886 133.563 92.9689 133.325 91.6909C133.087 90.4128 133.107 88.8833 133.219 87.8452C133.226 87.3354 132.741 86.9171 132.25 87.0086L128.612 87.6859C128.063 84.7366 127.514 81.7873 127.019 79.133C133.42 74.1774 136.865 65.9071 135.29 57.4525C133.075 45.5569 121.413 37.5566 109.321 39.8083C97.2292 42.06 89.3272 53.7034 91.5606 65.6972C93.1349 74.1519 99.3251 80.6281 107.081 82.9475C107.593 85.7002 108.124 88.5512 108.673 91.5005L104.938 92.1961C104.446 92.2877 104.144 92.8525 104.334 93.3257C104.812 94.2539 105.382 95.6736 105.62 96.9516C105.858 98.2297 105.837 99.7592 105.726 100.797C105.719 101.307 106.204 101.725 106.695 101.634L110.234 100.975C114.109 126.7 115.086 156.526 95.855 169.058C101.023 177.148 102.73 183.035 102.73 183.035L99.3882 188.032L100.395 193.439L172.948 179.928L171.941 174.521L167.006 170.965C167.006 170.965 166.578 164.84 168.39 155.449Z' fill='#FF0000')
                path(ref='elephant' d='M301.905 224.709C281.84 216.325 281.467 186.023 281.596 155.423C281.664 139.123 293.767 138.474 293.802 130.074C293.822 125.474 293.912 103.874 293.912 103.874L293.94 97.2745L285.84 97.2404L285.812 103.84L277.712 103.806L277.74 97.2064L269.64 97.1723L269.613 103.772L261.313 103.737L261.34 97.1374L253.24 97.1034L253.213 103.703L245.113 103.669L245.14 97.0694L237.141 97.0357L237.113 103.636C237.113 103.636 237.022 125.235 237.003 129.835C236.967 138.235 249.064 139.086 248.996 155.286C248.867 185.886 248.24 216.183 228.105 224.399C231.668 233.314 232.242 239.416 232.242 239.416L228.023 243.899L228 249.399L301.799 249.709L301.823 244.209L297.641 239.791C297.641 239.691 298.367 233.594 301.905 224.709Z' fill='white')
                use(href='#sparks' ref='sparks' x='60' y='15' transform='translate(-30 35) scale(0)')
                defs
                    g#sparks
                        path(d='M195.132 140.751L223.502 91.6573L237.685 92.6762L195.132 140.751Z' fill='#FF0000')
                        path(d='M193.441 118.621L191.62 61.9491L204.205 55.3271L193.441 118.621Z' fill='#FF0000')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'top-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline();
            this.timeline
                .set(this.$refs.parn, {rotate: 50, x: 10, y: 30})
                .set(this.$refs.elephant, {rotate: 0})
                .set(this.$refs.sparks, {scaleX: 0, scaleY: 0, x: -30, y: 35})
                .to(this.$refs.parn, {duration: 2, rotate: -22}, 0)
                .to(this.$refs.sparks, {duration: 1, scaleX: 1, scaleY: 1, x: 0, y: 0}, 1.7)
                .to(this.$refs.elephant, {duration: 2, rotate: 90, transformOrigin: '100% 100%'}, 2);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.animations {
    width: 100%;
}
</style>
